import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HistoryService } from '../services/history.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnDestroy, OnInit {
  public tpno : number;
  public payments : Array<Ipayement>;
  public tPaymentHistory$: Observable<boolean>;
  public selectedCriteria:number=0;
  public searchValue: any = '';
  dtOptions: any = { };
  // We use this trigger because fetching the list of purpose can be quite long,
  // thus we ensure the data is fetched before rendering
  dtTrigger: Subject<any> = new Subject();
  

  searchCriteria = [
    {value: "0", desc: "SELECT SEARCH CRITERIA"},
    {value: "1", desc: "ASSESSMENT NO."},
    {value: "2", desc: "RECEIPT NO."},
    {value: "3", desc: "DOCUMENT NO."},
    {value: "4", desc: "PAYMENT DATE"},
    {value: "5", desc: "TAX PERIOD"},
    {value: "6", desc: "ENTER DATE"}
  ];
  constructor(private history : HistoryService) { }

  ngOnInit() {
     this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      processing: true,
      paging:   true,
      ordering: true,
      info:     true,
      dom: 'Bfrtip',
        buttons: [
            'copy', 'csv', 'excel', 'print'
        ]
    }; 
    this.tpno = parseInt(localStorage.getItem("tpn"));
    this.tPaymentHistory$ = this.history.getPaymentHistorys(this.tpno).pipe(tap(r => {
      this.payments = this.history.paymentHistory;
      this.dtTrigger.next();
    }));
  }

  filterPaymentHistory(criteria:number, searchvalue:any){
    let originalPaymentData = this.payments;
    this.selectedCriteria= criteria;
    this.searchValue = searchvalue;
    if(this.selectedCriteria==1 && this.searchValue != ""){
      this.payments = this.payments.filter(element=>element.ASSMTNO==this.searchValue);
    }
    else if(this.selectedCriteria==2 && this.searchValue != ""){
      this.payments = this.payments.filter(e=>e.RECEIPT_NO==this.searchValue)
    }
    else if(this.selectedCriteria==3 && this.searchValue != ""){
      this.payments=this.payments.filter(e=>e.DOC_NO==this.searchValue)
    }
    else if(this.selectedCriteria==4 && this.searchValue != ""){
      this.payments=this.payments.filter(e=>e.PAYMENT_DATE==this.searchValue)
    }
    else if(this.selectedCriteria==5 && this.searchValue != ""){
      this.payments= this.payments.filter(e=>e.TAXPERIOD==this.searchValue);
    }
    else if(this.selectedCriteria==6 && this.searchValue != ""){
      this.payments= this.payments.filter(e=>e.ENTERDATE==this.searchValue);
    }
    else{
      this.payments = originalPaymentData;
    }
   
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    //throw new Error('Method not implemented.');
  }

}
